import { render } from "./anchorMdRecord.vue?vue&type=template&id=09cd19b5&scoped=true"
import script from "./anchorMdRecord.vue?vue&type=script&lang=js"
export * from "./anchorMdRecord.vue?vue&type=script&lang=js"

import "./anchorMdRecord.vue?vue&type=style&index=0&id=09cd19b5&lang=scss&scoped=true"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cd19b5"]])

export default __exports__